import { useEffect } from 'react';

export default function Toast({ message, type = '', onClose, duration = 1800 }) {
  useEffect(() => {
    const t = setTimeout(onClose, duration);
    return () => clearTimeout(t);
  }, [onClose, duration]);

  return <div className={`toast ${type}`}>{message}</div>;
}
